<template>
    <div class="container">
        <PatientsListingFilters :filters="params" :order-options="['oldest', 'newest']" @change="onFilters" />

        <div class="matrix-panel">
            <div class="table-layout table-patient table-clinician table-waiting table-doctor">
                <TableHeader v-if="patients.length !== 0" />

                <PatientsListingTableBody
                    ref="TableBody"
                    :phase="phase"
                    :params="params"
                    @fetched="onFetched"
                >
                    <PatientRow v-for="patient in patients" :key="patient.id" :patient="patient" />
                </PatientsListingTableBody>
            </div>
        </div>

        <flash-alert v-if="showAlert" @closeAlert="close" :text="__(alertText)" level="success"></flash-alert>
    </div>
</template>

<script>
import PatientRow from '@components/Doctors/PatientsMatrix/Onboarding/PatientRow'
import TableHeader from '@components/Doctors/PatientsMatrix/Onboarding/TableHeader'

import PatientsListing from '@components/PatientsMatrix/PatientsMatrix'

export default {
    components: {
        PatientRow,
        TableHeader
    },
    extends: PatientsListing,
    data() {
        return {
            showAlert: false,
            alertText: 'The invitation has been successfully sent.<span>Wait for patient registration via your unique code. Immediately afterwards, they will appear in the “active“ patients tab.</span>'
        }
    },
    mounted() {
        Vuemit.listen('FlashAlert--show', this.onResend)
    },
    methods: {
        onResend() {
            this.showAlert = true
        },
        close() {
            this.showAlert = false
        }
    }
}
</script>
